export default __webpack_public_path__ + "static/media/1852.ff3b3b9c.png";